import { FilterKey } from '@studyportals/search-filters';
import { FilterSelectionState } from '@/filters/selection/FilterSelectionState';
import { SeoHeadingHandlerDefaultSorting } from '../SeoHeadingHandlerDefaultSort';

export default class Countries extends SeoHeadingHandlerDefaultSorting {
	protected async canHandleWithDefaultSorting(filterSelectionState: FilterSelectionState): Promise<boolean> {
		return (
			(await this.selectionFor(FilterKey.COUNTRY, filterSelectionState)) &&
			[1, 2].includes(this.selectionTypeCount(filterSelectionState))
		);
	}

	protected async selfHandle(filterSelectionState: FilterSelectionState): Promise<string> {
		const singleSelectionForCountry = await this.singleSelectionFor(FilterKey.COUNTRY, filterSelectionState);

		const location = singleSelectionForCountry
			? this.getFilterOptionNameBy(FilterKey.COUNTRY, filterSelectionState)
			: 'selected countries';

		const seoInfo = `Comprehensive list of universities in ${location}`;

		return Promise.resolve(seoInfo);
	}
}
